<template>
  <div>
    <v-tooltip :text="appVersion">
      <template v-slot:activator="{ props }">
        <div
          class="transform -rotate-90 fixed bottom-12 -right-10 text-center z-[999] rounded"
          :style="{ backgroundColor: getBgColor }"
          v-bind="props"
        >
          <p class="uppercase text-xs text-white pa-1">{{ environment }}</p>
        </div>
      </template>
    </v-tooltip>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import packageJson from "../../../package.json";

const appVersion = `V ${packageJson?.version ?? "0.0.0"}`;

const environment = ref(import.meta.env.MODE);

const getBgColor = computed((): string => {
  if (environment.value.toLowerCase() == "staging") {
    return "#b8c174";
  }
  if (environment.value.toLowerCase() == "development") {
    return "#a4111a";
  }
  return "";
});
</script>
